import type { SVGProps } from 'react'

import {
  Headset,
  HardDrive,
  Keyboard,
  Laptop,
  Mobile,
  Desktop,
  Tablet,
  Watch,
} from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

type IconComponent = React.ForwardRefExoticComponent<
  Omit<SVGProps<SVGSVGElement>, 'ref'> & React.RefAttributes<SVGSVGElement>
>

/** Ordered list of category IDs shown in the sidebar */
export const CATEGORY_IDS = [
  'accessories',
  'audio_video',
  'computers',
  'mobile_phones',
  'monitors',
  'networking_it',
  'tablets',
  'wearables',
] as const

/** Icon for each category in the sidebar */
export const CATEGORY_ICONS: Record<string, IconComponent> = {
  accessories: Keyboard,
  audio_video: Headset,
  computers: Laptop,
  mobile_phones: Mobile,
  monitors: Desktop,
  networking_it: HardDrive,
  tablets: Tablet,
  wearables: Watch,
}

/**
 * Static i18n label map — avoids dynamic i18n keys (lint: factorial/no-dynamic-i18n).
 * Each value is a thunk to respect lazy i18n loading.
 */
export const CATEGORY_LABELS: Record<string, () => string> = {
  accessories: () => i18n.t('it_management.device_catalog.categories.accessories'),
  audio_video: () => i18n.t('it_management.device_catalog.categories.audio_video'),
  computers: () => i18n.t('it_management.device_catalog.categories.computers'),
  mobile_phones: () => i18n.t('it_management.device_catalog.categories.mobile_phones'),
  monitors: () => i18n.t('it_management.device_catalog.categories.monitors'),
  networking_it: () => i18n.t('it_management.device_catalog.categories.networking_it'),
  tablets: () => i18n.t('it_management.device_catalog.categories.tablets'),
  wearables: () => i18n.t('it_management.device_catalog.categories.wearables'),
}

/** Detail page mock data */
export const KEYBOARD_LANGUAGES = [
  { label: 'English (US)', value: 'en-us' },
  { label: 'English (UK)', value: 'en-gb' },
  { label: 'Spanish', value: 'es' },
  { label: 'French', value: 'fr' },
  { label: 'German', value: 'de' },
]

export const COUNTRIES = [
  { label: '🇪🇸 Spain', value: 'spain' },
  { label: '🇬🇧 United Kingdom', value: 'uk' },
  { label: '🇫🇷 France', value: 'fr' },
  { label: '🇩🇪 Germany', value: 'de' },
]

/** temporary hide some blocks */
export const SHOW_COUNTRY_SELECTOR = false
export const SHOW_KEYBOARD_LANGUAGE_SELECTOR = false

export const INSURANCE_PRICE = 4.99
export const IT_SUBSCRIPTION_PRICE = 9.99

export const DEVICE_CATALOG_MAX_QUANTITY = 1000
